import { pipe } from 'pipe-and-compose';

import { Product } from '../../types';
import { defaultTo } from '../../utils';

const defaultTo0 = defaultTo(0);

type ProductArg = Partial<Product>;

const getProductTotal = ({ quantity, price }: ProductArg) =>
  defaultTo0(quantity) * defaultTo0(price);

const getProductsPrice = pipe(
  defaultTo([]),
  (products: ReadonlyArray<ProductArg>) => products.reduce(
    (total, product) => total + getProductTotal(product),
    0,
  ),
)

export default getProductsPrice;
